// src/api/authService.js
import axios from "axios";
//import apiClient from "./apiClient";

const ACCESS_TOKEN = "accessToken";
const REFRESH_TOKEN = "refreshToken";
const BASE_URL = process.env.REACT_APP_API_URL;

// ✅ Login — use plain axios (not apiClient)
export const loginUser = async (username, password) => {
  const response = await axios.post(`${BASE_URL}/login`, { username, password });

  const { access_token, refresh_token } = response.data;

  // ✅ Store tokens using consistent key names
  localStorage.setItem(ACCESS_TOKEN, access_token);
  localStorage.setItem(REFRESH_TOKEN, refresh_token);

  return response.data;
};

// ✅ Get stored access token
export const getToken = () => localStorage.getItem(ACCESS_TOKEN);

// ✅ Logout — clear stored tokens
export const logoutUser = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
};

